import { compose, withProps } from 'recompose';

import { getGrossSalesKind } from '../helpers';
import withCurrency from '../../../common/hoc/withCurrency';

export default compose(
  withCurrency,
  withProps(props => ({ grossSalesKind: getGrossSalesKind(props.currency, props.taxes) })),
);
